export const TEN_PERCENT_TOLERANCE_COEFFICIENT = 1.1;
